"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var ToolBarDateRangeFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarDateRangeFilter");
var AppPaySystemTransactionList = /** @class */ (function (_super) {
    __extends(AppPaySystemTransactionList, _super);
    function AppPaySystemTransactionList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchOuterIdInput = null;
        _this.TRANSACTION_FILTER = "InnerPaymentDepositList-TransactionFilter";
        return _this;
    }
    AppPaySystemTransactionList.prototype.getDataOffset = function () {
        return (this.state.pageNum - 1) * this.state.pageSize;
    };
    AppPaySystemTransactionList.prototype.componentWillMount = function () {
        var _this = this;
        if (!this.props.state.getUIFilter().getUIFilterItemByKey(this.TRANSACTION_FILTER)) {
            this.props.state.getUIFilter().doUIRegisterFilterEmpty(this.TRANSACTION_FILTER);
        }
        this.setState({
            searchOuterIdFilter: this.props.state.getUIFilter().getUIFilterItemByKey(this.TRANSACTION_FILTER).selectedValues,
            searchOuterIdValue: this.props.state.getUIFilter().getUIFilterItemByKey(this.TRANSACTION_FILTER).filterValue,
            isSearchOuterId: this.props.state.getUIFilter().getUIFilterItemByKey(this.TRANSACTION_FILTER).isFilterActive,
        });
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total,
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat(),
            searchOuterIdFilter: [],
            searchOuterIdValue: "",
            complete_only: true,
            isSearchOuterId: false,
        }, function () {
            _this.loadData(_this.props);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    AppPaySystemTransactionList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    AppPaySystemTransactionList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                _this.loadData(nextProps);
            });
        }
    };
    AppPaySystemTransactionList.prototype.loadData = function (Props, onDone) {
        Props.data.LoadRangeDataByBrandsListEx({
            pay_service_id_list: this.props.servicesList,
            all_payservices: this.props.allServices,
            Limit: this.state.pageSize,
            Offset: this.getDataOffset(),
            from_year: this.state.dtFrom.get('year'),
            from_month: this.state.dtFrom.get('month') + 1,
            from_day: this.state.dtFrom.get('date'),
            from_hour: this.state.dtFrom.get('hour'),
            from_minute: this.state.dtFrom.get('minute'),
            to_year: this.state.dtTo.get('year'),
            to_month: this.state.dtTo.get('month') + 1,
            to_day: this.state.dtTo.get('date'),
            to_hour: this.state.dtTo.get('hour'),
            to_minute: this.state.dtTo.get('minute'),
            complete_only: this.state.complete_only,
            is_filter_transaction_part: this.state.isSearchOuterId,
            transaction_part: this.state.searchOuterIdValue
        }, function () {
            if (onDone) {
                onDone();
            }
        });
    };
    AppPaySystemTransactionList.prototype.onClearOuterIdFilter = function () {
        var _this = this;
        this.setState({
            searchOuterIdFilter: [],
            searchOuterIdValue: "",
            isSearchOuterId: false
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.TRANSACTION_FILTER, []);
            _this.props.state.getUIFilter().doUISetFilterValue(_this.TRANSACTION_FILTER, "");
            _this.props.state.getUIFilter().doUISetFilterActive(_this.TRANSACTION_FILTER, false);
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(1, _this.state.pageSize);
            }
        });
    };
    AppPaySystemTransactionList.prototype.onChangeOuterIdFilter = function (e) {
        var _this = this;
        this.setState({ searchOuterIdValue: e.target.value }, function () {
            _this.props.state.getUIFilter().doUISetFilterValue(_this.TRANSACTION_FILTER, _this.state.searchOuterIdValue);
        });
    };
    AppPaySystemTransactionList.prototype.onConfirmOuterIdFilter = function () {
        var _this = this;
        this.setState({
            searchOuterIdFilter: [this.state.searchOuterIdValue],
            isSearchOuterId: true
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.TRANSACTION_FILTER, [_this.state.searchOuterIdValue]);
            _this.props.state.getUIFilter().doUISetFilterActive(_this.TRANSACTION_FILTER, true);
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(1, _this.state.pageSize);
            }
        });
    };
    AppPaySystemTransactionList.prototype.getAdminColumns = function () {
        var _this = this;
        var _outerid_filter = this.state.searchOuterIdFilter;
        return [{
                title: 'Дата',
                dataIndex: this.props.data.dk_date_added,
                key: this.props.data.dk_date_added,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.state.dtFormat)));
                },
                width: 150
            }, {
                title: 'Игрок',
                dataIndex: this.props.data.dk_player_login,
                key: this.props.data.dk_player_login,
                width: 150,
            }, {
                title: 'EMail',
                dataIndex: this.props.data.dk_player_email,
                key: this.props.data.dk_player_email,
                width: 180,
            }, {
                title: 'Транзакция',
                dataIndex: this.props.data.dk_outer_transaction_id,
                key: this.props.data.dk_outer_transaction_id,
                width: 150,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchOuterIdInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438", value: _this.state.searchOuterIdValue, onChange: _this.onChangeOuterIdFilter.bind(_this), onPressEnter: function () { _this.onConfirmOuterIdFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmOuterIdFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearOuterIdFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _outerid_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.outer_transaction_id.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchOuterIdInput.focus();
                        });
                    }
                }
            }, {
                title: 'Сумма кошелька',
                dataIndex: this.props.data.dk_amount_in_player_currency,
                key: this.props.data.dk_amount_in_player_currency,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.amount_in_wallet_currency,
                        " ",
                        record.wallet_currency_title));
                }
            }, {
                title: 'Сумма игрока',
                dataIndex: this.props.data.dk_amount_in_player_currency,
                key: this.props.data.dk_amount_in_player_currency,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        UIUtils_1.UIUtils.formatCurrency(record.amount_in_player_currency),
                        " ",
                        record.player_currency_title));
                }
            }, {
                title: 'Кошелек',
                dataIndex: this.props.data.dk_wallet,
                key: this.props.data.dk_wallet,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.wallet));
                }
            }, {
                title: 'Тип кошелька',
                dataIndex: this.props.data.dk_crypto_wallet_type_title,
                key: this.props.data.dk_crypto_wallet_type_title,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.crypto_wallet_type_title));
                }
            }, {
                title: 'Статус',
                dataIndex: this.props.data.dk_deposit_state_title,
                key: this.props.data.dk_deposit_state_title,
                render: function (text, record, idx) {
                    if (record.deposit_state_complete) {
                        return (React.createElement("div", { style: { color: "#008000", fontWeight: "bold" } }, record.deposit_state_title));
                    }
                    if (record.deposit_state_error) {
                        return (React.createElement("div", { style: { color: "#FF0000", fontWeight: "bold" } }, record.deposit_state_title));
                    }
                    return (React.createElement("div", null, record.deposit_state_title));
                },
                width: 150,
            }, {
                title: 'Бренд',
                dataIndex: this.props.data.dk_brand_title,
                key: this.props.data.dk_brand_title,
                width: 150,
            }];
    };
    AppPaySystemTransactionList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        var _PageSize = this.state.pageSize;
        if (PageSize) {
            _PageSize = PageSize;
        }
        this.setState({ pageNum: _page, pageSize: _PageSize }, function () {
            _this.loadData(_this.props, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, _PageSize);
                }
            });
        });
    };
    AppPaySystemTransactionList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.loadData(this.props);
        }
    };
    AppPaySystemTransactionList.prototype.onServiceFilterChanged = function (allServices, ServiceId, Action) {
        if (this.props.onServiceFilterChanged) {
            this.props.onServiceFilterChanged(allServices, ServiceId, Action);
        }
    };
    //private onDepositTypeFilterChanged(allDepositTypes: boolean, DepositTypeCode: number, Action: "add" | "remove" | "checkbox") {
    //    if (this.props.onDepositTypeFilterChanged) {
    //        this.props.onDepositTypeFilterChanged(allDepositTypes, DepositTypeCode, Action);
    //    }
    //}
    AppPaySystemTransactionList.prototype.onSelectRange = function (DtFrom, DtTo) {
        this.props.state.setDateFrom(DtFrom).setDateTo(DtTo, true);
    };
    AppPaySystemTransactionList.prototype.onCheckBoxChecked = function (checked) {
        this.setState({ complete_only: checked });
    };
    AppPaySystemTransactionList.prototype.getToolbarRenderObject = function () {
        return (React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
            React.createElement("div", { style: { display: "flex", flexWrap: "nowrap", justifyContent: "flex-start", alignItems: "center" } },
                React.createElement("div", { style: { marginLeft: "2px", marginRight: "2px" } }, "\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u044B\u0435"),
                React.createElement(antd_1.Switch, { checked: this.state.complete_only, onChange: this.onCheckBoxChecked.bind(this) })),
            React.createElement(ToolBarDateRangeFilter_1.default, { title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442: ", from: { date: this.state.dtFrom, title: "Начало" }, to: { date: this.state.dtTo, title: "Окончание" }, onClick: this.onSelectRange.bind(this) }),
            React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allServices, availBrands: this.props.availServices, captions: { checkbox: "Все сервисы: ", placeholder: "Выберите сервис" }, selectedBrands: this.props.servicesList, onBrandFilterChanged: this.onServiceFilterChanged.bind(this) })));
    };
    AppPaySystemTransactionList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            this.getToolbarRenderObject(),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getAdminColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                            " [",
                            record.date_changed.format(_this.props.state.getDateTimeFormat()),
                            "]")));
                }, scroll: { x: true } })));
    };
    return AppPaySystemTransactionList;
}(React.Component));
exports.default = AppPaySystemTransactionList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/app_paysystem_transactions/ui/component/AppPaySystemTransactionLists.tsx
// module id = 2574
// module chunks = 0